/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../core/abstractions/base.model';

export class FormattedAddressRequestModel extends BaseModel {
    locationId: number;
    street: string;
    number: string;
    streetSupplement: string;
    poBox: string;
    streetAfterSupplement: boolean;
    isPoBox: boolean;
    languageId: string;
    isConfidential: boolean;
    companyName: string;
    companyDepartment: string;
    companyNameFirst: boolean;
    firstName: string;
    lastName: string;
    firstNameSupplement: string;
    lastNameSupplement: string;
    hasHyphen: boolean;
    jobTitle: string;
    shortSalutation: string;
    salutationTitle: string;
    isCommunity: boolean;

    constructor(init?: Partial<FormattedAddressRequestModel>) {
        super();
        Object.assign(this, init);
    }
}
